import { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";

import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

import heroImage from "../assets/hero.jpg";

import kdhHighroof from "../assets/kdh-highroof.png";
import bus from "../assets/bus.png";

import aboutTaxi from "../assets/about-taxi.jpg";

import vehicle1 from "../assets/1.jpeg";
import vehicle2 from "../assets/2.jpeg";
import vehicle3 from "../assets/3.jpeg";

import place1 from "../assets/place20.jpg";
import place2 from "../assets/place11.jpg";
import place3 from "../assets/place13.jpg";
import place4 from "../assets/place17.jpg";
import place5 from "../assets/place23.jpg";
import place6 from "../assets/place24.jpg";

function Home() {
  const navigate = useNavigate();

  useEffect(() => {
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100,
    });
  }, []);

  const vehicles = [
    { id: 1, image: vehicle1, name: "28 seater with jumping" },
    { id: 2, image: vehicle2, name: "35 seater" },
    { id: 3, image: vehicle3, name: "51 seater" },
  ];

  return (
    <div className="w-full overflow-hidden">
      
      {/* ================= HERO SECTION ================= */}
      <section className="relative min-h-screen w-full">

        {/* Background Image */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${heroImage})` }}
        />

        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black/80" />

        {/* Content */}
        <div
          data-aos="fade-up"
          className="relative z-10 flex min-h-screen flex-col items-center justify-center px-4 text-center text-white"
        >
          {/* Brand */}
          <p className="mb-3 text-xs uppercase tracking-widest text-yellow-400 sm:text-sm">
            Richie Travel
          </p>

          {/* Heading */}
          <h1 className="mb-5 max-w-4xl text-3xl font-extrabold leading-tight sm:text-4xl md:text-5xl lg:text-6xl">
            Sri Lanka Taxi Service <br />
            <span className="text-yellow-400">& In-Bound Tours</span>
          </h1>

          {/* Subtitle */}
          <p className="mb-8 max-w-2xl text-sm text-gray-200 sm:text-base md:text-lg">
            Ride with Convenience and Comfort through Richie Travel
          </p>

          {/* Buttons */}
          <div className="flex flex-col gap-4 sm:flex-row">
            <a
              href="https://wa.me/94705152858"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 rounded-lg bg-yellow-400 px-6 py-3 text-sm font-semibold text-black transition hover:bg-yellow-500 sm:px-8 sm:text-base"
            >
              📲 Book Now Whatsapp
            </a>

            <a
              href="tel:+94705152858"
              className="flex items-center justify-center gap-2 rounded-lg border border-yellow-400 px-6 py-3 text-sm font-semibold text-yellow-400 transition hover:bg-yellow-400 hover:text-black sm:px-8 sm:text-base"
            >
              📞 Call Now
            </a>
          </div>
        </div>
      </section>

      {/* ================= VEHICLE PRICING SECTION ================= */}
      <section className="relative w-full bg-white py-10">
        {/* Overlay */}
        <div className="absolute inset-0 bg-white/80" />

        <div className="relative z-10 mx-auto max-w-7xl px-4 text-center text-black">
          {/* Heading */}
          <h2
            data-aos="fade-up"
            className="mb-4 text-3xl font-extrabold sm:text-4xl md:text-5xl"
          >
            Premium Vehicle Services For Your Journey
          </h2>

          <div className="mx-auto mb-16 h-1 w-24 bg-yellow-400" />

          {/* Services */}
          <div className="grid grid-cols-1 gap-16 md:grid-cols-2">

            {/* ================= KDH HIGHROOF VAN ================= */}
            <div
              data-aos="fade-up"
              className="rounded-2xl border border-yellow-400 bg-white/60 p-8"
            >
              <div className="mb-6 flex justify-center">
                <img
                  src={kdhHighroof}
                  alt="KDH Highroof Van"
                  className="h-40 object-contain"
                />
              </div>

              <h3 className="mb-4 text-2xl font-bold text-yellow-400">
                KDH Highroof Van
              </h3>

              <p className="mb-6 text-sm leading-relaxed text-black-300">
                Ideal for airport transfers, family trips, group tours, and long
                distance travel. Enjoy maximum comfort, safety, and spacious seating
                with our well-maintained KDH Highroof vans.
              </p>

              <ul className="mb-6 space-y-2 text-sm text-black-300">
                <li>✔ Air-conditioned & comfortable seating</li>
                <li>✔ Suitable for 6–10 passengers</li>
                <li>✔ Airport & city transfers</li>
                <li>✔ Professional English-speaking drivers</li>
              </ul>

              <a
                href="https://wa.me/94705152858"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block rounded-lg bg-yellow-400 px-8 py-3 text-sm font-semibold text-black transition hover:bg-yellow-500"
              >
                Book KDH Van
              </a>
            </div>

            {/* ================= LUXURY BUS ================= */}
            <div
              data-aos="fade-up"
              data-aos-delay="150"
              className="rounded-2xl border border-yellow-400 bg-white/60 p-8"
            >
              <div className="mb-6 flex justify-center">
                <img
                  src={bus}
                  alt="Luxury Bus"
                  className="h-40 object-contain"
                />
              </div>

              <h3 className="mb-4 text-2xl font-bold text-yellow-400">
                Luxury Bus Service
              </h3>

              <p className="mb-6 text-sm leading-relaxed text-black-300">
                Perfect for large groups, corporate travel, school trips, and tour
                groups. Our luxury buses provide a smooth, safe, and enjoyable journey
                across Sri Lanka.
              </p>

              <ul className="mb-6 space-y-2 text-sm text-black-300">
                <li>✔ Comfortable reclining seats</li>
                <li>✔ Large group capacity</li>
                <li>✔ Long-distance & tour packages</li>
                <li>✔ Experienced and licensed drivers</li>
              </ul>

              <a
                href="tel:+94705152858"
                className="inline-block rounded-lg bg-yellow-400 px-8 py-3 text-sm font-semibold text-black transition hover:bg-yellow-500"
              >
                Call for Bus
              </a>
            </div>

          </div>
        </div>
      </section>

      {/* ================= ABOUT US SECTION ================= */}
      <section className="w-full bg-white py-10">
        <div className="mx-auto max-w-7xl px-4">
          <div className="grid grid-cols-1 items-center gap-12 md:grid-cols-2">

            <div
              data-aos="fade-right"
              className="relative h-[450px] w-full overflow-hidden rounded-xl md:h-[500px]"
            >
              <img
                src={aboutTaxi}
                alt="Taxi Service"
                className="h-full w-full object-fill"
              />

              {/* Experience Badge */}
              <div className="absolute bottom-0 left-0 w-full bg-yellow-400 py-0 text-center">
                <h3 className="text-1xl font-extrabold text-black sm:text-2xl">
                  More Than 20 Years <br /> of Experience
                </h3>
              </div>
            </div>

            {/* RIGHT CONTENT */}
            <div data-aos="fade-left">
              <p className="mb-2 text-sm font-semibold uppercase tracking-widest text-yellow-500">
                About Us
              </p>

              <h2 className="mb-6 text-3xl font-extrabold text-black sm:text-4xl">
                Driving Trust and <br /> Excellence
              </h2>

              <p className="mb-6 text-gray-700 leading-relaxed">
                Richie Travel is one of the most popular, reliable, safe, and
                comfortable tourist taxi service companies in Sri Lanka. We offer
                high-quality, on-time taxi services and tours using a wide range of
                vehicles with professional, experienced drivers.
              </p>

              {/* FEATURES */}
              <ul className="space-y-3">
                <li className="flex items-start gap-3">
                  <span className="text-yellow-500">✔</span>
                  <span className="text-gray-700">
                    Reliable and punctual tour transport services
                  </span>
                </li>

                <li className="flex items-start gap-3">
                  <span className="text-yellow-500">✔</span>
                  <span className="text-gray-700">
                    Airport transfers, city tours, day trips & tour packages
                  </span>
                </li>

                <li className="flex items-start gap-3">
                  <span className="text-yellow-500">✔</span>
                  <span className="text-gray-700">
                    Logistics and freight transport services
                  </span>
                </li>

                <li className="flex items-start gap-3">
                  <span className="text-yellow-500">✔</span>
                  <span className="text-gray-700">
                    Hassle-free hotel booking with competitive rates
                  </span>
                </li>

                <li className="flex items-start gap-3">
                  <span className="text-yellow-500">✔</span>
                  <span className="text-gray-700">
                    24/7 professional customer support
                  </span>
                </li>
              </ul>

              {/* BUTTON */}
              <button
                onClick={() => navigate("/about")}
                className="mt-8 rounded-lg bg-black px-8 py-3 text-sm font-semibold text-yellow-400 transition hover:bg-gray-900"
              >
                Read More
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* ================= VEHICLE SLIDESHOW SECTION ================= */}
      <section className="relative w-full bg-white py-10 overflow-hidden">
        <div className="mx-auto max-w-7xl px-4 text-center">

          <p className="mb-2 text-sm font-semibold uppercase tracking-widest text-yellow-500">
            Our Fleet
          </p>

          <h2 className="mb-14 text-3xl font-extrabold text-black sm:text-4xl">
            Wide Range of Vehicles
          </h2>

          {/* Slider wrapper */}
          <div className="relative overflow-hidden">

            {/* Left fade */}
            <div className="pointer-events-none absolute inset-y-0 left-0 z-10 w-24 bg-gradient-to-r from-white to-transparent" />
            {/* Right fade */}
            <div className="pointer-events-none absolute inset-y-0 right-0 z-10 w-24 bg-gradient-to-l from-white to-transparent" />

            {/* Auto sliding row */}
            <motion.div
              className="
                flex items-center
                justify-center sm:justify-start
                gap-10 sm:gap-16 md:gap-24
                px-6 sm:px-0
              "
              animate={{ x: ["0%", "-100%"] }}
              transition={{
                repeat: Infinity,
                duration: 12,
                ease: "linear",
              }}
            >
              {[...vehicles, ...vehicles].map((vehicle, index) => (
                <div
                  key={index}
                  className="min-w-[280px] sm:min-w-[360px] md:min-w-[420px] flex flex-col items-center"
                >

                  <img
                    src={vehicle.image}
                    alt={vehicle.name}
                    className="
                      h-56 sm:h-64 md:h-72
                      w-auto
                      object-contain
                      transition-transform duration-300
                      hover:-translate-y-2
                    "
                  />

                  <h3 className="mt-4 text-base font-semibold text-gray-900 transition-colors duration-300 group-hover:text-yellow-500">
                    {vehicle.name}
                  </h3>

                </div>
              ))}
            </motion.div>
          </div>

        </div>
      </section>

      {/* ================= SERVICES SECTION ================= */}
      <section className="relative w-full bg-black py-10">
        {/* Background Overlay */}
        <div className="absolute inset-0 bg-black/80" />

        <div className="relative z-10 mx-auto max-w-7xl px-4 text-center text-white">
          {/* Title */}
          <h2
            data-aos="fade-up"
            className="mb-4 text-3xl font-extrabold sm:text-4xl md:text-5xl"
          >
            We Offer You a Complete Service For Your Journey
          </h2>

          <div className="mx-auto mb-16 h-1 w-24 bg-yellow-400" />

          {/* Services */}
          <div className="grid grid-cols-1 gap-12 md:grid-cols-3">

            {/* Transport & Tours */}
            <div data-aos="fade-up" className="px-6">
              <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-yellow-400">
                🚕
              </div>

              <h3 className="mb-4 text-xl font-bold text-yellow-400">
                Transport & Tours
              </h3>

              <p className="text-sm leading-relaxed text-gray-300">
                Provide well-maintained, high-quality cars, mini-vans, mini-coaches
                and large coaches for a defined number of guests, sourced from
                reliable suppliers.
              </p>
            </div>

            {/* Logistics & Freight */}
            <div data-aos="fade-up" data-aos-delay="150" className="px-6">
              <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-yellow-400">
                🚚
              </div>

              <h3 className="mb-4 text-xl font-bold text-yellow-400">
                Logistics & Freight
              </h3>

              <p className="text-sm leading-relaxed text-gray-300">
                Streamline your cargo movement with Richie Travel logistics services,
                ensuring efficient and timely delivery of your goods.
              </p>
            </div>

            {/* Hotel Booking */}
            <div data-aos="fade-up" data-aos-delay="300" className="px-6">
              <div className="mx-auto mb-6 flex h-16 w-16 items-center justify-center rounded-full bg-yellow-400">
                🏨
              </div>

              <h3 className="mb-4 text-xl font-bold text-yellow-400">
                Hotel Booking
              </h3>

              <p className="text-sm leading-relaxed text-gray-300">
                We help you find and book the best value hotels quickly and
                efficiently — completely free of charge.
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* ================= PLACES SECTION ================= */}
      <section className="w-full bg-white py-10">
        <div className="mx-auto max-w-7xl px-4">

          {/* Heading */}
          <div className="mb-14 text-center">
            <h2
              data-aos="fade-up"
              className="text-3xl font-extrabold text-black sm:text-4xl md:text-5xl"
            >
              Popular Places in Sri Lanka
            </h2>
            <div className="mx-auto mt-4 h-1 w-24 bg-yellow-400" />
          </div>

          {/* Cards Grid */}
          <div className="grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-3">

            {[
              {
                id: "galle",
                img: place1,
                title: "Galle",
                desc: "The city of Galle is about a two-hour drive from Colombo via one of the country’s first modern superhighways. This...",
              },
              {
                id: "jaffna",
                img: place2,
                title: "Jaffna",
                desc: "Jaffna is a city located on the northern tip of Sri Lanka. It opened its doors to tourism in 2009....",
              },
              {
                id: "trincomalee",
                img: place3,
                title: "Trincomalee",
                desc: "Trincomalee is a great little town on the east coast of Sri Lanka. Trincomalee offers beautiful white sand and has...",
              },
              {
                id: "anuradhapura",
                img: place4,
                title: "Anuradhapura",
                desc: "A visit to Anuradhapura, one of the country’s ancient capitals, rewards visitors with a glimpse into the past. The area...",
              },
              {
                id: "polonnaruwa",
                img: place5,
                title: "Polonnaruwa",
                desc: "Polonnaruwa is an ancient city in north-central Sri Lanka, famous for its well-preserved ruins, sacred temples, and impressive stone sculptures...",
              },
              {
                id: "katharagama",
                img: place6,
                title: "Katharagama",
                desc: "Kataragama is a popular spiritual and cultural destination in southeastern Sri Lanka, known for its sacred temples and vibrant religious atmosphere...",
              },
            ].map((place, index) => (
              <div
                key={index}
                data-aos="fade-up"
                data-aos-delay={index * 100}
                className="overflow-hidden rounded-xl border border-gray-200 shadow-sm transition hover:shadow-lg"
              >
                {/* Image */}
                <img
                  src={place.img}
                  alt={place.title}
                  className="h-56 w-full object-cover"
                />

                {/* Content */}
                <div className="p-6">
                  <h3 className="mb-2 text-lg font-bold text-black">
                    {place.title}
                  </h3>

                  <p className="mb-4 text-sm text-gray-600">
                    {place.desc}
                  </p>

                  <button
                    onClick={() => navigate(`/places/${place.id}`)}
                    className="rounded bg-yellow-400 px-5 py-2 text-sm font-semibold text-black transition hover:bg-yellow-500"
                  >
                    Read More
                  </button>
                </div>
              </div>
            ))}
          </div>

          {/* See More Button */}
          <div className="mt-16 text-center">
            <button
              onClick={() => navigate("/places")}
              className="rounded-lg bg-black px-8 py-3 text-sm font-semibold text-yellow-400 transition hover:bg-gray-900"
            >
              See More Places
            </button>
          </div>

        </div>
      </section>

      {/* ================= TAXI CTA SECTION ================= */}
      <section className="w-full bg-[#f7f7f7] py-16">
        <div className="mx-auto max-w-7xl px-4">
          <div className="grid grid-cols-1 items-center gap-10 md:grid-cols-2">

            {/* LEFT CONTENT */}
            <div
              data-aos="fade-right"
              className="flex flex-col items-center text-center"
            >
              <h2 className="mb-4 text-3xl font-extrabold text-black sm:text-4xl">
                Book your Taxi Today!
              </h2>

              <p className="mb-6 max-w-xl text-gray-700">
                Richie Travel is the best and no.1 Taxi & Tour service provider in Sri
                Lanka. We always offer you the best Taxi deals covering all islands.
              </p>

              <p className="mb-6 text-2xl font-bold text-black">
                +94 70 515 2858
              </p>

              <a
                href="tel:+94743205692"
                className="inline-block rounded bg-black px-8 py-3 text-sm font-semibold text-yellow-400 transition hover:bg-gray-900"
              >
                Contact Us
              </a>
            </div>


            {/* RIGHT IMAGE */}
            <div
              data-aos="fade-left"
              className="flex justify-center md:justify-end"
            >
              <img
                src={bus}
                alt="Taxi Service"
                className="max-w-full object-contain"
              />
            </div>

          </div>
        </div>
      </section>

      {/* ================= WHATSAPP BUTTON ================= */}
      <a
        href="https://wa.me/94705152858"
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-5 right-5 z-50"
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/thumb/6/6b/WhatsApp.svg/512px-WhatsApp.svg.png"
          alt="WhatsApp"
          className="h-12 w-12 rounded-full shadow-lg transition hover:scale-110 sm:h-14 sm:w-14"
        />
      </a>
    </div>
  );
}

export default Home;
